export default {"src":"/_next/static/image/public/images/flags/flag_1473.e4038610caa61e2174fad72f2cc15ac7.svg","height":16,"width":25};